module.exports = __webpack_public_path__ + "img/magento-services-integration_medium.b2d0fcbc.jpg";